module.exports = __webpack_public_path__ + "static/CLS_UI_shot-93401334cbe0bb3286378d7a25a0cf14.png";